<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g id="server 1, storage, data, coins, money">
      <path
        id="Icon"
        d="M15.0312 5.82465C15.0312 6.71157 13.0025 7.43056 10.5 7.43056C7.99746 7.43056 5.96875 6.71157 5.96875 5.82465M15.0312 5.82465C15.0312 4.93774 13.0025 4.21875 10.5 4.21875C7.99746 4.21875 5.96875 4.93774 5.96875 5.82465M15.0312 5.82465V14.1753C15.0312 15.0623 13.0025 15.7812 10.5 15.7812C7.99746 15.7812 5.96875 15.0623 5.96875 14.1753V5.82465M15.0312 10C15.0312 10.8629 13.0025 11.5625 10.5 11.5625C7.99746 11.5625 5.96875 10.8629 5.96875 10"
        class="stroke-current"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'StorageIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
